import jsPDF from "jspdf";
import { toast } from "react-toastify";
import { captureReceiptCanvas } from "./captureReceiptCanvas";

export const shareReceiptAsPdf = async (
  el: HTMLDivElement,
  reference: string | undefined,
  filePrefix = "transaction"
): Promise<void> => {
  try {
    const canvas = await captureReceiptCanvas(el);

    const imgData = canvas.toDataURL("image/png");
    const pxToMm = (px: number) => px * 0.264583;

    const pdfWidth = pxToMm(canvas.width);
    const pdfHeight = pxToMm(canvas.height);

    const pdf = new jsPDF({
      orientation: pdfHeight > pdfWidth ? "portrait" : "landscape",
      unit: "mm",
      format: [pdfWidth, pdfHeight],
    });

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${filePrefix}-${reference ?? "receipt"}.pdf`);
  } catch {
    toast.error("Failed to generate PDF");
  }
};
